(function () {
  const preloader = document.getElementById('site-preloader');
  if (!preloader) return;

  const minDuration = parseInt(preloader.dataset.minDuration || '800', 10);
  const oncePerSession = preloader.dataset.oncePerSession === 'true';
  const storageKey = 'allure-preloader-seen';

  const hide = () => {
    preloader.classList.add('is-hidden');
    document.documentElement.classList.remove('preloader-active');
    window.setTimeout(() => preloader.remove(), 500);
  };

  if (oncePerSession) {
    try {
      if (sessionStorage.getItem(storageKey) === '1') {
        hide();
        return;
      }
      sessionStorage.setItem(storageKey, '1');
    } catch (e) {}
  }

  document.documentElement.classList.add('preloader-active');
  const startedAt = Date.now();

  const finish = () => {
    const elapsed = Date.now() - startedAt;
    const wait = Math.max(0, minDuration - elapsed);
    window.setTimeout(hide, wait);
  };

  if (document.readyState === 'complete') {
    finish();
  } else {
    window.addEventListener('load', finish, { once: true });
    window.setTimeout(finish, 4000);
  }
})();
